import React from "react";
import banner from '../assets/videomain.mp4';

const SecondSec = () => {
  return (
    <>
      {/* Custom Cursor */}
      <div className="custom-cursor"></div>
      <div className="cursor-follower"></div>

      {/* Section Content */}
      <section className="sec-two" id="second">
       <div className="container">
         {/* Background Video */}
         <div className="video-container1">
          <video autoPlay loop muted playsInline className="background-video">
            <source src={banner} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>

        {/* Text Overlay */}
        <div className="text-overlay">
          <div className="container">
            <div className="row">
              <div className="text-box">
                <h2>
                  Let's grow <span>together!</span>
                </h2>
                <p>
                  When you choose to work with Apex Web Experts, you're not just
                  hiring an agency. You're partnering with a dedicated team of
                  professionals invested in your success. We focus on forging
                  long-term relationships with our clients, and we're committed
                  to supporting your business growth every step of the way.
                </p>
              </div>
            </div>
          </div>
        </div>
       </div>
      </section>
    </>
  );
};

export default SecondSec;
